import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Dil dosyaları
import tr from './locales/tr.json';
import en from './locales/en.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import es from './locales/es.json';
import it from './locales/it.json';
import ru from './locales/ru.json';
import ar from './locales/ar.json';
import zh from './locales/zh.json';
import ja from './locales/ja.json';

const resources = {
  tr: { translation: tr },
  en: { translation: en },
  de: { translation: de },
  fr: { translation: fr },
  es: { translation: es },
  it: { translation: it },
  ru: { translation: ru },
  ar: { translation: ar },
  zh: { translation: zh },
  ja: { translation: ja }
};

const savedLanguage = localStorage.getItem('appLanguage') || 'tr';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage, // Varsayılan veya kaydedilmiş dil
    fallbackLng: 'tr', // Yedek dil
    interpolation: {
      escapeValue: false, // React zaten XSS koruması sağlıyor
    },
    debug: false, // Geliştirme modunda true yapabilirsiniz
  });

export default i18n;
